import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  connect() {
    this.overlay = null
  }

  open(event) {
    const img = event.currentTarget
    const src = img.src
    const alt = img.alt

    // Create overlay
    this.overlay = document.createElement("div")
    this.overlay.className = "fixed inset-0 z-50 flex items-center justify-center bg-black/90 cursor-zoom-out"
    this.overlay.addEventListener("click", () => this.close())

    // Create zoomed image
    const zoomedImg = document.createElement("img")
    zoomedImg.src = src
    zoomedImg.alt = alt
    zoomedImg.className = "max-w-[90vw] max-h-[90vh] object-contain rounded-lg"

    this.overlay.appendChild(zoomedImg)
    document.body.appendChild(this.overlay)
    document.body.classList.add("overflow-hidden")

    // Close on escape
    this.escapeHandler = (e) => {
      if (e.key === "Escape") this.close()
    }
    document.addEventListener("keydown", this.escapeHandler)
  }

  close() {
    if (this.overlay) {
      this.overlay.remove()
      this.overlay = null
      document.body.classList.remove("overflow-hidden")
      document.removeEventListener("keydown", this.escapeHandler)
    }
  }

  disconnect() {
    this.close()
  }
}
